import {useEffect, useRef} from "react";

export const useKeypress = (opts: {
  code: KeyboardEvent["code"];
  onKey: () => void;
  withMeta?: boolean;
  withAlt?: boolean;
}) => {
  const {code, onKey, withMeta, withAlt} = opts;
  const cbRef = useRef(onKey);
  useEffect(() => {
    cbRef.current = onKey;
  });
  useEffect(() => {
    const handler = (e: KeyboardEvent) => {
      if (e.code === code) {
        if (withMeta && !e.metaKey) return;
        if (withAlt && !e.altKey) return;
        cbRef.current();
        e.preventDefault();
        e.stopPropagation();
      }
    };
    window.addEventListener("keydown", handler);
    return () => window.removeEventListener("keydown", handler);
  }, [code, withMeta, withAlt]);
};

export const useEsc = (onKey: () => void) => {
  return useKeypress({code: "Escape", onKey});
};
